import { DataLineDefs } from './DataLines';
import { PointsDefs } from './Points';
import { ContentDefs } from './Content';

export const EffectDefs = () => {
    return (
        <defs>
            <PointsDefs />

            <ContentDefs />

            <radialGradient id="mouse">
                <stop offset="10%" stopColor="white" />
                <stop offset="95%" stopColor="transparent" />
            </radialGradient>

            <symbol
                id="startMask"
                width="140"
                height="320"
                viewBox="0 0 140 320"
                fill="none"
                preserveAspectRatio="xMaxYMin">
                <polygon
                    vectorEffect="non-scaling-stroke"
                    points="70,0, 140,0, 140,320, 70,320, 140,160"
                    fill="black"></polygon>
            </symbol>

            <symbol
                id="endMask"
                width="140"
                height="320"
                viewBox="0 0 140 320"
                fill="none"
                preserveAspectRatio="xMinYMin">
                <polygon
                    vectorEffect="non-scaling-stroke"
                    points="0,0, 70,0, 0,160, 70,320, 0,320"
                    fill="black"></polygon>
            </symbol>

            <DataLineDefs />
        </defs>
    );
};
